<section class="ecb-course-payment-section">
  <div class="container">
    <div class="ecb-course-payment-card">

      <div class="ecb-course-payment-header">
        <span class="ecb-course-payment-tag">
          VERIFICATION OF COMPETENCY
        </span>

        <h1>VOC Course Payment</h1>

        <p>
          Enter your job number and email address to find your VOC
          request and continue to secure payment.
        </p>
      </div>

      <div class="ecb-course-payment-body">

        <!-- Search Section -->
        <div class="ecb-course-payment-search-section" *ngIf="!vocDetails">



          <div class="row">

            <div class="col-6">
              <div class="mb-3">
                <label for="vocJobNumber">
                  Job Number
                </label>

                <input id="vocJobNumber" type="text" class="form-control ecb-course-payment-job-input"
                  [(ngModel)]="jobNumber" name="jobNumber" placeholder="Enter your job number"
                  [disabled]="isSearching || isCreatingCheckout">
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="vocEmailAddress">
                  Email Address
                </label>
                <input id="vocEmailAddress" type="email" class="form-control ecb-course-payment-job-input"
                  [(ngModel)]="enteredEmailAddress" name="emailAddress" placeholder="Enter your email address"
                  [attr.readonly]="isEmailReadOnly ? '' : null" [disabled]="isSearching || isCreatingCheckout"
                  (keyup.enter)="searchVOCDetails()">
              </div>
            </div>
          </div>




          <button type="button" class="btn ecb-course-payment-search-button" [disabled]="
              isSearching ||
              isCreatingCheckout ||
              !jobNumber.trim() ||
              !enteredEmailAddress.trim()
            " (click)="searchVOCDetails()">
            <i class="bi" [ngClass]="
                isSearching
                  ? 'bi-arrow-repeat ecb-spin'
                  : 'bi-search'
              "></i>

            {{ isSearching ? 'Searching...' : 'Search' }}
          </button>

          <small>
            Enter the job number and email address supplied to ECB
            Training Services.
          </small>
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="alert alert-danger ecb-course-payment-alert" role="alert">
          <i class="bi bi-exclamation-circle-fill"></i>

          {{ errorMessage }}
        </div>

        <!-- Payment Success Message -->
        <div *ngIf="paymentSuccessMessage" class="alert alert-success ecb-course-payment-alert" role="alert">
          <i class="bi bi-check-circle-fill"></i>

          {{ paymentSuccessMessage }}
        </div>

        <!-- Search Success Message -->
        <div *ngIf="successMessage" class="alert alert-success ecb-course-payment-alert" role="alert">
          <i class="bi bi-check-circle-fill"></i>

          {{ successMessage }}
        </div>

        <!-- Email Mismatch Warning -->
        <div *ngIf="vocDetails && !isMatching" class="alert alert-warning ecb-course-payment-alert" role="alert">
          <div class="d-flex align-items-start gap-3">

            <i class="bi bi-exclamation-triangle-fill fs-4"></i>

            <div class="flex-grow-1">
              <h6 class="alert-heading mb-2">
                Email Address Does Not Match
              </h6>

              <p class="mb-2">
                The email address
                <strong>{{ enteredEmailAddress }}</strong>
                does not match the email registered for this VOC
                course booking.
              </p>

              <p class="mb-3">
                Please check the entered email address and job number.
              </p>

              <button type="button" class="btn btn-outline-secondary" (click)="resetEmailVerification()">
                <i class="bi bi-x-circle me-2"></i>
                Try Again
              </button>
            </div>

          </div>
        </div>

        <!-- VOC Details -->
        <div *ngIf="vocDetails && isMatching" class="ecb-course-payment-details">
          <div class="ecb-course-payment-details-header">

            <div>
              <span>VOC Request Found</span>
              <h2>Payment Details</h2>
            </div>

            <span class="ecb-course-payment-status" [ngClass]="{
                'ecb-status-paid': isPaymentCompleted(),

                'ecb-status-pending':
                  !vocDetails.paymentStatus ||
                  vocDetails.paymentStatus.toLowerCase() === 'pending',

                'ecb-status-failed':
                  vocDetails.paymentStatus?.toLowerCase() === 'failed'
              }">
              {{ vocDetails.paymentStatus || 'Pending' }}
            </span>

          </div>

          <div class="ecb-course-payment-details-grid">

            <div class="ecb-course-payment-detail-item">
              <span>Job Number</span>

              <strong>
                {{ vocDetails.jobNumber || '-' }}
              </strong>
            </div>

            <div class="ecb-course-payment-detail-item">
              <span>Client Email</span>

              <strong>
                {{ vocDetails.clientEmail || '-' }}
              </strong>
            </div>

            <div class="ecb-course-payment-detail-item">
              <span>Created Date</span>

              <strong>
                {{
                vocDetails.createdDate
                ? (vocDetails.createdDate |
                date:'dd/MM/yyyy hh:mm a')
                : '-'
                }}
              </strong>
            </div>

            <div class="ecb-course-payment-detail-item">
              <span>Course Fee</span>

              <strong class="ecb-course-payment-fee">
                {{
                courseFee |
                currency:'AUD':'symbol':'1.2-2'
                }}
              </strong>
            </div>

          </div>

          <!-- Uploaded Form -->
          <a *ngIf="vocDetails.requestFormUrl" [href]="vocDetails.requestFormUrl" target="_blank"
            rel="noopener noreferrer" class="ecb-course-payment-form-link">
            <i class="bi bi-file-earmark-pdf-fill"></i>

            View Uploaded VOC Request Form
          </a>

          <!-- Already Paid -->
          <div *ngIf="isPaymentCompleted()" class="ecb-course-payment-completed">
            <i class="bi bi-check-circle-fill"></i>

            <div>
              <strong>Payment Completed</strong>

              <p>
                This VOC request has already been paid.
              </p>
            </div>
          </div>

          <!-- Payment Button -->
          <button *ngIf="!isPaymentCompleted()" type="button" class="btn ecb-course-payment-pay-button"
            [disabled]="isCreatingCheckout || courseFee <= 0" (click)="payNow()">
            <i class="bi" [ngClass]="
                isCreatingCheckout
                  ? 'bi-arrow-repeat ecb-spin'
                  : 'bi-lock-fill'
              "></i>

            {{
            isCreatingCheckout
            ? 'Redirecting to Payment...'
            : 'Pay Securely'
            }}
          </button>

        </div>
      </div>
    </div>
  </div>
</section>